import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'rename-modal',
  templateUrl: 'rename-modal.component.html',
  styleUrls: ['../general.scss']
})
export class RenameModalComponent {
    public name: string;

    constructor(@Inject(MAT_DIALOG_DATA) data: any, private dialogRef: MatDialogRef<RenameModalComponent>) {
        console.log('injected data:');
        console.log(data);
        this.name = data.name;
    }

    public save() {
        this.dialogRef.close(this.name);
    }
}
